const getStatusErrors = (status, privilege) => {
  const errors = Array.isArray(status?.map?.errors) ? status.map.errors : [];
  if (!(Number(privilege) >= 4)) return errors;

  const owners = new Map();

  Object.entries(status?.controlVariables || {}).forEach(([control, fields]) => {
    if (!Array.isArray(fields)) return;
    fields.forEach((field) => {
      if (typeof field !== 'string') return;
      if (!owners.has(field)) owners.set(field, new Set());
      owners.get(field).add(control);
    });
  });

  const conflicts = [...owners.keys()]
    .filter((field) => owners.get(field).size > 1)
    .sort()
    .map((field) => ({
      identifier: `merge-conflict:${field}`,
      severity: 'WARNING',
      area: 'MERGE CONFLICT',
      info: `${field} is published by ${[...owners.get(field)].sort().join(' and ')}. Use distinct machine identifiers.`,
      startDate: '',
      lastDate: '',
      threshold: 0
    }));

  return conflicts.length ? [...errors, ...conflicts] : errors;
};

export default getStatusErrors;
